export default __webpack_public_path__ + "static/Montserrat-ThinItalic-3096cb47ac2a0c8020aa9a4b570dbe1c.ttf";